import NotAllowed from './NotAllowed';

export default NotAllowed;
